import { render, staticRenderFns } from "./approvalStages.vue?vue&type=template&id=50ae8a64"
import script from "./approvalStages.vue?vue&type=script&lang=js"
export * from "./approvalStages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports